import type { PropsWithChildren } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Navigate } from 'react-router-dom';
import type { ProfileResponse } from '@masha/shared';
import { api } from '../lib/api';

export function AdminGuard({ children }: PropsWithChildren) {
  const { data } = useQuery<ProfileResponse>({
    queryKey: ['profile'],
    queryFn: () => api.getProfile(),
  });
  if (!data) return null;
  if (!data.user.isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}
